import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { OfferProduct } from './offerproduct';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { OfferProductType } from '../types';
import { ProductOptType } from '../types';

const _schema = {
    "name": "OFFERPRODUCTOPT",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "product", type: "objid" },
        { name: "prodopt", type: "objid", alias: "option" },
    ],
    relate: [
        { direction: ">", target: "OFFERPRODUCT", by: "product", name: "product", reason: "product", child: false, class: OfferProductType },
        { direction: ">", target: "PRODUCTOPT", by: "option", name: "option", reason: "option", child: false, class: ProductOptType }
    ]
} as const;

const _OfferOptionClass = CreateObject(_schema);
if (!_OfferOptionClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class OfferOption extends _OfferOptionClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): OfferOption {
        return this._Copy(store) as OfferOption;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'product' && related instanceof OfferProduct){
            if (related === this.product){
                related.AddOption(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/
    
    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.product){
            if ((this.status == 'DE') && !this.Commited){
                this.product.DelOption(this);
            }
            else {
                this.product.DoRefresh(this.table);
            }    
        }
    }    
    
    get grouped(): number {
        return this['__base__grouped'] || 0;
    }

    set grouped(value: number){
        this['__base__grouped'] = value;
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }    
}
